import { render, staticRenderFns } from "./frontFormPerfil.vue?vue&type=template&id=589ada77&scoped=true&"
import script from "./frontFormPerfil.vue?vue&type=script&lang=js&"
export * from "./frontFormPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ada77",
  null
  
)

export default component.exports